import { Error401ScreenContainer } from "src/containers";

export const Error401Screen = () => {
  return <Error401ScreenContainer />;
};
